class TokenService {
  getLocalRefreshToken() {
    const user = JSON.parse(localStorage.getItem("user"));

    return user?.refreshToken.token ?? "";
  }

  getLocalAccessToken() {
    const user = JSON.parse(localStorage.getItem("user"));

    return user?.accessToken.token ?? "";
  }

  getLocalClaims() {
    const user = JSON.parse(localStorage.getItem("user"));

    return user?.claims ?? [];
  }

  updateLocalTokens(tokens) {
    var user = this.getUser();
    user.accessToken.token = tokens.accessToken; // Assumes tokens has accessToken string
    user.refreshToken.token = tokens.refreshToken; // Assumes tokens has refreshToken string

    // If the tokens structure changed to strings directly now:
    // This method depends on what calls updateLocalTokens.
    // Assuming backend also returns strings for refresh.

    localStorage.setItem("user", JSON.stringify(user));
  }

  getUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  setUser(user) {
    // The response has accessToken (string), refreshToken (string), userId, firstName, lastName etc.
    // We update local storage accordingly. The expiration isn't in the response, would need decoding.
    // For now we assume no complex expiration logic or just minimal storage.
    var userData = {
      accessToken: {
        token: user.accessToken,
        // expiration: user.accessToken.expirationDate, // Not provided
      },
      refreshToken: {
        token: user.refreshToken,
      },
      userId: user.userId,
      firstName: user.firstName,
      lastName: user.lastName,
      // isCoach: user.isCoach, // Not in new response
    };
    localStorage.setItem("user", JSON.stringify(userData));
  }

  updateUserName(firstName, lastName) {
    const user = this.getUser();
    if (user) {
      user.firstName = firstName;
      user.lastName = lastName;
      localStorage.setItem("user", JSON.stringify(user));
    }
  }

  removeUser() {
    localStorage.removeItem("user");
  }
}

export default new TokenService();
